var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5928 4.0791H11.4775C10.0661 4.07909 8.94813 4.07908 8.07321 4.19718C7.17279 4.31873 6.444 4.57482 5.86926 5.15187C5.29451 5.72892 5.03945 6.46064 4.91839 7.36467C4.80076 8.2431 4.80077 9.36552 4.80078 10.7826V15.4526C4.80078 16.6591 5.53674 17.693 6.58252 18.1265C6.52869 17.3989 6.52873 16.378 6.52878 15.5287L6.52878 11.5972L6.52878 11.521C6.52872 10.4957 6.52867 9.61225 6.62341 8.90479C6.72494 8.1466 6.95389 7.41983 7.54102 6.83035C8.12815 6.24086 8.85201 6.01098 9.60717 5.90905C10.3118 5.81393 11.1917 5.81398 12.2129 5.81404L12.2888 5.81404H14.5928L14.6686 5.81404C15.6899 5.81398 16.5679 5.81393 17.2725 5.90905C16.8509 4.83733 15.8101 4.0791 14.5928 4.0791Z",
    fill: "#591528"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68078 11.5972C7.68078 9.41622 7.68078 8.32574 8.35561 7.6482C9.03043 6.97067 10.1165 6.97067 12.2888 6.97067H14.5928C16.765 6.97067 17.8511 6.97067 18.526 7.6482C19.2008 8.32574 19.2008 9.41622 19.2008 11.5972V15.4526C19.2008 17.6336 19.2008 18.724 18.526 19.4016C17.8511 20.0791 16.765 20.0791 14.5928 20.0791H12.2888C10.1165 20.0791 9.03043 20.0791 8.35561 19.4016C7.68078 18.724 7.68078 17.6336 7.68078 15.4526V11.5972Z",
    fill: "#591528"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyFill);
export default __webpack_public_path__ + "static/media/Copy-fill.91ed867aed8932c373d10796e08924fd.svg";
export { ForwardRef as ReactComponent };